
export enum BoxSideRelativeToWindow {
    Gauche,
    Derrière,
    Droite,
    Avant,
}
